import ReactPixel from "react-facebook-pixel";
import { useGaTracking } from "./useGaTracking";

type SendPurchaseEventParams = {
  value: number;
  currency: string;
  transactionId?: string;
  itemId?: number;
  itemName?: string;
};

export function useSendPurchaseEvent() {
  const { trackGaEvent } = useGaTracking();

  const sendPurchaseEvent = ({
    value,
    currency,
    transactionId,
    itemId,
    itemName,
  }: SendPurchaseEventParams) => {
    if (import.meta.env.PROD) {
      // GA4 purchase event
      trackGaEvent("purchase", {
        currency,
        value,
        transaction_id: transactionId,
        items: [
          {
            item_id: itemId ? String(itemId) : undefined,
            item_name: itemName ?? "Subscription",
            item_category: "Subscription",
            price: value,
            quantity: 1,
          },
        ],
      });

      // Facebook Pixel
      try {
        ReactPixel.track("Subscribe", {
          value,
          currency,
        });
      } catch {
        // Meta Pixel may be blocked by ad blockers
      }
    }
  };

  return { sendPurchaseEvent };
}
